import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import * as S from './Counter-styled';

/**
 * Used for showing filtered total out of grand total.
 * Additional icon can be passed to show after the grand total
 * TODO - remember to use it in libs/asm-ng/src/components/Technologies/components/TableTopBar/index.jsx
 * */
export const CountersSummary = ({
  filteredCount,
  filteredLoading,
  filteredTestId,
  label,
  totalCount,
  totalLoading,
  totalSuffix,
  totalTestId,
  icon
}) => (
  <S.Counters>
    <S.FilteredCount>
      {filteredLoading ? (
        <CircularProgress size={14} />
      ) : (
        <span data-testid={filteredTestId}>{filteredCount?.toLocaleString() || 0}</span>
      )}{' '}
      {label}
    </S.FilteredCount>
    <S.GrandTotalAndIcon>
      <S.GrandTotal data-testid={totalTestId}>
        {totalCount != null && (
          <>
            / <Trans i18nKey="common.outOf" values={{ count: totalLoading ? '' : totalCount?.toLocaleString() }} />
            {/* Glued to the number, unlike `icon` — for approximate totals rendered as "1,000+". */}
            {!totalLoading && totalSuffix}
          </>
        )}
        {!!totalLoading && <CircularProgress size={14} />}
      </S.GrandTotal>
      {icon}
    </S.GrandTotalAndIcon>
  </S.Counters>
);

CountersSummary.propTypes = {
  filteredCount: PropTypes.number,
  filteredLoading: PropTypes.bool,
  filteredTestId: PropTypes.string,
  label: PropTypes.node,
  totalCount: PropTypes.number,
  totalLoading: PropTypes.bool,
  totalSuffix: PropTypes.node,
  totalTestId: PropTypes.string,
  icon: PropTypes.node
};
